import { AdFrequencyController } from "./types";
import { AdFrequencyControllerImpl } from "./AdFrequencyController";

export function getAdfrequencyController(): AdFrequencyController {
    return AdFrequencyControllerImpl.getInstance();
}
